import React from "react";
import { Child } from "../../models/ParticipantRegistration";
import EAIconButton from "../shared/Buttons/EAIconButton";
import { MdEdit, MdDelete } from "react-icons/md";
import "./style.scss";

interface IProps {
  child: Child;
  onEdit: () => void;
  onDelete: () => void;
}

const ChildCard: React.FC<IProps> = ({ child, onEdit, onDelete }) => {
  return (
    <div className="child-card">
      <div className="child-card__content">
        <p className="child-card__name">
          {child.name} {child.lastName}
        </p>
        <p className="child-card__age">{child.age} lat</p>
      </div>
      <div className="child-card__actions">
        <EAIconButton title="Edytuj" icon={<MdEdit />} onClick={onEdit} variant="icon" compact />
        <EAIconButton title="Usuń" icon={<MdDelete />} onClick={onDelete} variant="icon" compact />
      </div>
    </div>
  );
};

export default ChildCard;

